module.exports = __webpack_public_path__ + "img/6.8c9b78f7.jpg";